import 'jquery';

/**
 * toggle Loading behavior of forms
 */
(function ($) {

  let inputs = $(':input[data-transform="postbox"]');

  if (!inputs.length) {
    return;
  }

  let
    chunk_split = function (text, chunklen, end) {
      chunklen = parseInt(chunklen, 10) || 2;
      end = end || ' ';
      text = text.replace(/\D+/g, '');
      if (chunklen < 1) {
        return text;
      }
      return $.trim(text.match(new RegExp('.{0,' + chunklen + '}', 'g')).join(end));
    },
    formatToView = function (inputs) {
      inputs.each(function () {
        let text = $(this).val();
        if (!text) {
          return true;
        }
        $(this).val(chunk_split(text));
      });
    },
    formatToSave = function (inputs) {
      inputs.each(function () {
        let text = $(this).val();
        if (!text) {
          return true;
        }
        $(this).val(text.replace(/\D+/g, ''));
      });
    };

  formatToView(inputs);

  $(document).on('submit', 'form', function () {
    formatToSave(inputs);
  }).on('input', ':input[data-transform=postbox]', function () {
    formatToView(inputs);
  });

}(jQuery));